import React from "react";
import { styled } from "@material-ui/core/styles";
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru'

const Cell = styled("div")({
    display: "flex",
    alignItems: "center"
});

const calcToday = (date) => format(
    parseISO(date),
    'dd.MM.yy',
    {locale: ru}
);

const RequestDateCell = cellData => {
    const { date } = cellData.data;

    return <Cell>{date && calcToday(date)}</Cell>;
};

export default RequestDateCell;
